import React from 'react';

const HomeIcon: React.FC = () => (
  <div className="w-[62px] h-[62px] rounded-full bg-[#32395E] flex items-center justify-center">
    <svg
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.9018 11.998L17.7768 1.08879C17.7704 1.08386 17.7643 1.07855 17.7588 1.07289C16.7574 0.270648 15.2278 0.270648 14.2265 1.07289L14.2084 1.08879L1.0982 11.998C0.557527 12.436 0.249888 13.0535 0.25 13.7006V27.0625C0.25 28.3397 1.42525 29.375 2.875 29.375H10.75C12.1997 29.375 13.375 28.3397 13.375 27.0625V20.125H18.625V27.0625C18.625 28.3397 19.8003 29.375 21.25 29.375H29.125C30.5747 29.375 31.75 28.3397 31.75 27.0625V13.7006C31.7501 13.0535 31.4425 12.436 30.9018 11.998ZM29.125 27.0625H21.25V20.125C21.25 18.8478 20.0747 17.8125 18.625 17.8125H13.375C11.9253 17.8125 10.75 18.8478 10.75 20.125V27.0625H2.875V13.7006L2.89305 13.6861L16 2.78125L29.1086 13.6832L29.1266 13.6977L29.125 27.0625Z"
        fill="white"
      />
    </svg>
  </div>
);

export default HomeIcon;
